import React, { useState, useEffect, useRef, useCallback, createContext, useContext, useMemo } from 'react';
import './navbar.css'; // Or './nfcnavbar-navbar.css' if you renamed it
import logo from "./1.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faXTwitter, faFacebookF, faYoutube, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
// --- 0. CONTEXT FOR USER ACTIVITY ---
const NavbarContext = createContext();


const NavbarProvider = ({ children }) => {
  const [userActivity, setUserActivity] = useState({ hoverCount: 0, lastInteraction: Date.now() });
  const recordInteraction = useCallback(() => {
    setUserActivity(prev => ({ hoverCount: prev.hoverCount + 1, lastInteraction: Date.now() }));
  }, []);


  useEffect(() => {
    document.documentElement.setAttribute('data-nfcnavbar-theme', 'graphite-light');
    const root = document.documentElement;
    root.style.setProperty('--nfcnavbar-color-base-rgb', '255, 255, 255'); 
    root.style.setProperty('--nfcnavbar-color-text-rgb', '20, 23, 26');
    root.style.setProperty('--nfcnavbar-color-surface-rgb', '255, 255, 255');
    root.style.setProperty('--nfcnavbar-color-accent-primary-rgb', '59, 130, 246');
    root.style.setProperty('--nfcnavbar-color-accent-secondary-rgb', '107, 114, 128');

    return () => {
        document.documentElement.removeAttribute('data-nfcnavbar-theme');
        root.style.removeProperty('--nfcnavbar-color-base-rgb');
        root.style.removeProperty('--nfcnavbar-color-text-rgb');
        root.style.removeProperty('--nfcnavbar-color-surface-rgb');
        root.style.removeProperty('--nfcnavbar-color-accent-primary-rgb');
        root.style.removeProperty('--nfcnavbar-color-accent-secondary-rgb');
    };
  }, []);


  return <NavbarContext.Provider value={{ recordInteraction, userActivity }}>{children}</NavbarContext.Provider>;
};


const useNavbar = () => useContext(NavbarContext);


// --- 1. MODULAR NAVBAR COMPONENTS ---


// 1.0 Generic Icon Component
const Icon = ({ name, size = 20 }) => {
  const paths = {
    instagram: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.359 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.947s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
    whatsapp: "M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.39 1.26 4.85l-1.33 4.86 4.99-1.31c1.43.77 3.04 1.22 4.75 1.22h.01c5.46 0 9.91-4.45 9.91-9.91s-4.45-9.91-9.91-9.91zm0 18.06c-1.51 0-2.96-.41-4.22-1.14l-.3-.18-3.14.82.83-3.06-.2-.31c-.81-1.28-1.3-2.79-1.3-4.38 0-4.53 3.69-8.21 8.21-8.21 4.53 0 8.21 3.69 8.21 8.21s-3.69 8.21-8.21 8.21zm4.52-6.13c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.79.97-.15.17-.29.19-.56.06-.25-.12-1.1-.41-2.09-1.29-.77-.69-1.29-1.54-1.44-1.8-.15-.25-.02-.39.11-.5.11-.11.25-.29.37-.43.12-.15.17-.25.25-.41.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.02 2.56.12.17 1.76 2.67 4.27 3.75 2.51 1.08 2.51.72 2.96.69.45-.03 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.12-.23-.19-.48-.31z",
    close: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  };
  return <svg className="nfcnavbar-icon" viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true"><path d={paths[name] || ''}></path></svg>;
};


// 1.1 AnimatedLogo
const AnimatedLogo = () => {
  const { recordInteraction } = useNavbar();
  const handleLogoClick = (e) => {
    recordInteraction();
  };

  return (
    <a href="/" className="nfcnavbar-navbar__logo-link" aria-label="NowNFC Homepage" onClick={handleLogoClick}>
       <img className="nfcnavbar-navbar__logo-svg" src={logo} alt="NowNFC logo" />
    </a>
  );
};


function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => { clearTimeout(timeout); func(...args); };
    clearTimeout(timeout); timeout = setTimeout(later, wait);
  };
}


// 1.2 NavLinks
const NavLinks = ({ items, activeSection, onItemClick, isMobile = false }) => {
  const { recordInteraction } = useNavbar();
  const debouncedMouseMoveHandler = useMemo(
    () => debounce(recordInteraction, 150),
    [recordInteraction]
  );

  return (
    <ul className={`nfcnavbar-navbar__menu-links ${isMobile ? 'nfcnavbar-navbar__menu-links--mobile' : ''}`} onMouseMove={!isMobile ? debouncedMouseMoveHandler : undefined}>
      {items.map((item, index) => (
        <li key={item.id} className={`nfcnavbar-navbar__item ${isMobile ? 'nfcnavbar-navbar__item--mobile' : ''}`} style={isMobile ? { animationDelay: `${index * 0.05}s` } : {}}>
          <a href={item.href} className={`nfcnavbar-navbar__link ${isMobile ? 'nfcnavbar-navbar__link--mobile' : ''} ${activeSection === item.id ? 'nfcnavbar-navbar__link--active' : ''}`} aria-current={activeSection === item.id ? 'page' : undefined} onClick={(e) => { onItemClick(e, item.label, item.href, item.id); recordInteraction(); }}>
            <span>{item.label}</span> {item.isNew && <span className="nfcnavbar-new-indicator-dot" title="New Content"></span>}
          </a>
        </li>
      ))}
    </ul>
  );
};


// 1.3 CallToActionButton
const CallToActionButton = ({ onClick, isMobile = false }) => {
  const { recordInteraction } = useNavbar();
  const [isRippling, setIsRippling] = useState(false);
  const rippleTimeoutRef = useRef(null);
  const handleClick = (e) => {
    recordInteraction(); onClick(e);
    const ctaButton = e.currentTarget; const rect = ctaButton.getBoundingClientRect(); const ripple = ctaButton.querySelector('.nfcnavbar-cta__ripple'); 
    if (ripple) { ripple.style.left = `${e.clientX - rect.left}px`; ripple.style.top = `${e.clientY - rect.top}px`;}
    setIsRippling(true); if (rippleTimeoutRef.current) clearTimeout(rippleTimeoutRef.current);
    rippleTimeoutRef.current = setTimeout(() => setIsRippling(false), 600);
  };
  useEffect(() => { return () => { if (rippleTimeoutRef.current) clearTimeout(rippleTimeoutRef.current); }; }, []);

  return (
    <a href="/login" className={`nfcnavbar-navbar__cta ${isMobile ? 'nfcnavbar-navbar__cta--mobile' : ''} ${isRippling ? 'nfcnavbar-is-rippling' : ''}`} >
      <span className="nfcnavbar-cta__text" >Get Started</span> 
      <span className="nfcnavbar-cta__ripple"></span>
    </a>
  );
};


// 1.4 SocialLinks Component
const SocialLinks = ({ items, isMobile = false }) => {
  if (!items || items.length === 0) return null;
  return (
    <ul className={`nfcnavbar-navbar__social-links ${isMobile ? 'nfcnavbar-navbar__social-links--mobile' : ''}`}>
      {items.map((item, index) => (
        <li key={item.id} className="nfcnavbar-social-links__item" style={isMobile ? { animationDelay: `calc(var(--nfcnavbar-social-base-delay, 0s) + ${index * 0.04}s)` } : {}}>
          <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label} className="nfcnavbar-social-links__link">
            <Icon name={item.iconName} size={isMobile ? 24 : 20} /> 
          </a>
        </li>
      ))}
    </ul>
  );
};


// 1.5 LoginLink Component
const LoginLink = ({ item, onItemClick, isMobile = false, animationDelay = "0s" }) => {
  const { recordInteraction } = useNavbar();
  if (!item) return null;
  const mobileClass = isMobile ? 'nfcnavbar-navbar__login-link--mobile' : 'nfcnavbar-client-portal-btn';

  return (
    <a href={item.href} className={`nfcnavbar-navbar__login-link ${mobileClass}`} onClick={(e) => { onItemClick(e, item.label, item.href, item.id); recordInteraction(); }} style={isMobile ? { animationDelay } : {}}>
      {item.label}
    </a>
  );
};


// 1.6 MobileMenuOverlay
const MobileMenuOverlay = ({ isOpen, menuItems, loginItem, socialItems, activeSection, onItemClick, ctaOnClick, onClose }) => {
  const menuRef = useRef(null);
  const firstFocusableElementRef = useRef(null);
  const lastFocusableElementRef = useRef(null);

  const baseDelayUnit = 0.05;
  const closeButtonAnimationDelay = '0.02s';
  const loginAnimationDelay = useMemo(() => `${menuItems.length * baseDelayUnit + 0.1}s`, [menuItems.length]);
  const ctaAnimationDelay = useMemo(() => `${menuItems.length * baseDelayUnit + 0.15}s`, [menuItems.length]);
  const connectPromptAnimationDelay = useMemo(() => `${(menuItems.length + 1) * baseDelayUnit + 0.2}s`, [menuItems.length]);
  const socialBaseAnimationDelay = useMemo(() => `${(menuItems.length + 1.5) * baseDelayUnit + 0.2}s`, [menuItems.length]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (menuRef.current) {
        menuRef.current.style.setProperty('--nfcnavbar-social-base-delay', socialBaseAnimationDelay); 
      }

      const focusableElements = menuRef.current?.querySelectorAll(
        'button:not([disabled]), a[href]:not([disabled])'
      );
      if (focusableElements && focusableElements.length > 0) {
        firstFocusableElementRef.current = focusableElements[0];
        lastFocusableElementRef.current = focusableElements[focusableElements.length - 1];
        setTimeout(() => firstFocusableElementRef.current?.focus(), 100);
      }
      const handleKeyDown = (event) => {
        if (event.key === 'Escape') { onClose(); }
        if (event.key === 'Tab') {
          if (!firstFocusableElementRef.current || !lastFocusableElementRef.current) return;
          if (event.shiftKey) { if (document.activeElement === firstFocusableElementRef.current) { lastFocusableElementRef.current.focus(); event.preventDefault();}}
          else { if (document.activeElement === lastFocusableElementRef.current) { firstFocusableElementRef.current.focus(); event.preventDefault();}}
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => { document.body.style.overflow = ''; document.removeEventListener('keydown', handleKeyDown);};
    } else { document.body.style.overflow = ''; }
  }, [isOpen, onClose, socialBaseAnimationDelay, menuItems]);

  return (
    <div ref={menuRef} className={`nfcnavbar-mobile-menu__overlay ${isOpen ? 'nfcnavbar-is-open' : ''}`} role="dialog" aria-modal="true" aria-labelledby="nfcnavbar-mobile-menu-heading" id="nfcnavbar-mobileMenuOverlay"> 
      <button className="nfcnavbar-mobile-menu__close-button" onClick={onClose} aria-label="Close navigation menu" style={{ animationDelay: closeButtonAnimationDelay }}>
        <Icon name="close" size={24} />
      </button>
      <div className="nfcnavbar-mobile-menu__content">
        <h2 id="nfcnavbar-mobile-menu-heading" className="nfcnavbar-sr-only">Navigation Menu</h2> 

        <NavLinks items={menuItems} activeSection={activeSection} onItemClick={onItemClick} isMobile={true} />
        
        {/* FIX: Client Portal and Get Started buttons are grouped for consistent styling */}
        <div className="nfcnavbar-mobile-menu__secondary-actions" style={{animationDelay: loginAnimationDelay}}>
            <LoginLink item={loginItem} onItemClick={onItemClick} isMobile={true} />
            <CallToActionButton onClick={ctaOnClick} isMobile={true} />
        </div>

        {socialItems && socialItems.length > 0 && (
          <div className="nfcnavbar-mobile-menu__social-group" style={{animationDelay: connectPromptAnimationDelay}}>
            <div className="nfcnavbar-mobile-menu__connect-prompt">
              <p>Stay Connected</p>
            </div>
            <SocialLinks items={socialItems} isMobile={true} />
          </div>
        )}
      </div>
    </div>
  );
};


// --- MASTER NAVBAR COMPONENT (SmartNavbar) ---
const SmartNavbar = () => {
  const { recordInteraction, userActivity } = useNavbar();
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [activeSection, setActiveSection] = useState(''); 
  const [headerStyles, setHeaderStyles] = useState({});
  const lastScrollY = useRef(0);
  const headerRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const mobileMenuTriggerRef = useRef(null);
  const isClickScrolling = useRef(false);
  const scrollTimeoutRef = useRef(null);


  useEffect(() => {
    setIsMounted(true);
    const skipLink = document.createElement('a');
    skipLink.href = "#main-content"; 
    skipLink.className = "nfcnavbar-skip-to-content"; 
    skipLink.innerText = "Skip to main content";
    if (document.body) {
     document.body.insertBefore(skipLink, document.body.firstChild);
    }
    return () => {
      if (skipLink.parentNode) document.body.removeChild(skipLink);
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
    };
  }, []);

  const menuItems = useMemo(() => [
    { id: 'home', label: 'Home', href: '/' },
    { id: 'features', label: 'Features', href: '/features', },
    { id: 'about', label: 'About', href: '/about' }, 
     { id: 'Pricing', label: 'Pricing', href: '/pricing' }, 
    { id: 'contact', label: 'Contact', href: '/contact' },
    { id: 'Faq', label: 'Faq', href: '/faq' },

  ], []);

  useEffect(() => {
     if (menuItems.length > 0) {
         const currentPath = window.location.pathname;
         const itemFromUrl = menuItems.find(item => item.href === currentPath) || menuItems[0];
         setActiveSection(itemFromUrl.id);
     }
  }, [menuItems]);

  const loginItem = useMemo(() => ({ id: 'login', label: 'Client Portal', href: '/booking' }), []);

  const socialItems = useMemo(() => [
    { id: 'instagram', label: 'Follow on Instagram', href: 'https://instagram.com/example', iconName: 'instagram' },
    { id: 'whatsapp', label: 'Contact on WhatsApp', href: 'https://wa.me/1234567890', iconName: 'whatsapp' },
  ], []);

  const handleScroll = useCallback(() => {
    if (isClickScrolling.current) return;

    const currentScrollY = window.scrollY;
    const headerHeight = headerRef.current?.offsetHeight || 70;

    if (currentScrollY > lastScrollY.current && currentScrollY > headerHeight * 1.1) {
      setIsHeaderVisible(false);
    } else {
      setIsHeaderVisible(true);
    }
    lastScrollY.current = currentScrollY;

    const scrollMax = document.documentElement.scrollHeight - window.innerHeight;
    const scrollRatio = scrollMax > 0 ? Math.min(currentScrollY / scrollMax, 1) : 0;
    const newStyles = { 
      '--nfcnavbar-header-scale': `${1 - scrollRatio * 0.005}`,
      '--nfcnavbar-header-blur-intensity': `calc(12px + ${scrollRatio * 10}px)`,
      '--nfcnavbar-header-shadow-opacity': `${0.04 + scrollRatio * 0.08}`,
      '--nfcnavbar-header-bg-opacity': `${0.9 - scrollRatio * 0.15}`
    };
    setHeaderStyles(newStyles);
    
    // This scroll-based active section logic is more for single-page apps with scrollable sections.
    // The primary active state is now handled by the click handler and URL.
    menuItems.forEach(item => {
      const sectionId = item.href.startsWith('#') ? item.href.substring(1) : item.id;
      const section = document.getElementById(sectionId); 
      if (section) {
        const sectionTop = section.offsetTop;
        const triggerPoint = sectionTop - headerHeight - window.innerHeight * 0.25;
        if (currentScrollY >= triggerPoint && currentScrollY < triggerPoint + section.offsetHeight) {
            if (activeSection !== item.id) {
                setActiveSection(item.id);
            }
        }
      }
    });
  }, [menuItems, activeSection]);

  useEffect(() => {
    const debouncedScrollHandler = debounce(handleScroll, 10);
    window.addEventListener('scroll', debouncedScrollHandler, { passive: true });
    const recordScrollInteraction = debounce(() => recordInteraction(), 500);
    window.addEventListener('scroll', recordScrollInteraction, { passive: true });
    handleScroll(); 
    return () => {
      window.removeEventListener('scroll', debouncedScrollHandler);
      window.removeEventListener('scroll', recordScrollInteraction);
    }
  }, [handleScroll, recordInteraction]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => {
      const shouldOpen = !prev;
      if (!shouldOpen && mobileMenuTriggerRef.current) {
        mobileMenuTriggerRef.current.focus();
      }
      return shouldOpen;
    });
  };

  const smoothScrollTo = (targetId) => {
    const targetElement = document.getElementById(targetId); 
    if (targetElement) {
      const headerOffset = headerRef.current?.offsetHeight || 70;
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset - 15; 
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    } else {
      console.warn(`Smooth scroll target element "#${targetId}" not found on page.`);
    }
  }

  // FIX: This function now handles both page navigation and in-page scrolling correctly.
  const handleItemClick = (e, label, href, sectionId) => {
    recordInteraction();
    setActiveSection(sectionId); // Set active state immediately on click.
    
    if (isMobileMenuOpen) {
        setTimeout(() => setIsMobileMenuOpen(false), 250);
    }
    
    // If it's an in-page anchor link (starts with #), scroll smoothly.
    if (href.startsWith('#')) {
        e.preventDefault(); // Prevent page reload for anchor links.
        isClickScrolling.current = true;
        scrollTimeoutRef.current = setTimeout(() => { isClickScrolling.current = false; }, 1000);
        smoothScrollTo(href.substring(1));
    } else {
        // For actual page links, navigate the browser.
        // The component will re-render on the new page and set the correct active state.
        window.location.href = href;
    }
  };

  const handleCtaClick = (e) => {
    e.preventDefault();
    recordInteraction();
    const targetId = e.currentTarget.getAttribute('href')?.substring(1);
    
    if (targetId) {
      setActiveSection(targetId);
      isClickScrolling.current = true;
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        isClickScrolling.current = false;
      }, 1000);
    }
    
    if (isMobileMenuOpen) {
      setTimeout(() => {
        setIsMobileMenuOpen(false);
        if (mobileMenuTriggerRef.current) mobileMenuTriggerRef.current.focus();
      }, 250);
    }
    
    if (targetId) {
      smoothScrollTo(targetId);
    } else {
       console.warn("CTA href attribute is missing or invalid for smooth scroll.");
    }
  };

  let presencePulseIntensity = 0.8;
  if (userActivity.hoverCount > 2 && userActivity.hoverCount <= 5) presencePulseIntensity = 1.0;
  else if (userActivity.hoverCount > 5) presencePulseIntensity = 1.15;

  if (Date.now() - userActivity.lastInteraction > 10000 && Date.now() - userActivity.lastInteraction <= 25000) {
    presencePulseIntensity = Math.max(presencePulseIntensity, 1.1);
  } else if (Date.now() - userActivity.lastInteraction > 25000) {
    presencePulseIntensity = 0.7;
  }

  return (
    <>
      <header 
        ref={headerRef} 
        className={`nfcnavbar-site-header ${!isHeaderVisible && !isMobileMenuOpen ? 'nfcnavbar-site-header--hidden' : ''} ${isMounted ? 'nfcnavbar-is-mounted' : ''} ${isMobileMenuOpen ? 'nfcnavbar-mobile-menu-is-active' : ''}`} 
        id="nfcnavbar-site-header" 
        style={{...headerStyles, '--nfcnavbar-presence-pulse-intensity': presencePulseIntensity }}> 
        <nav className="nfcnavbar-navbar" aria-label="Main navigation">
          <AnimatedLogo />
          <div className="nfcnavbar-navbar__center-group">
            <NavLinks items={menuItems} activeSection={activeSection} onItemClick={handleItemClick} isMobile={false} />
          </div>
          <div className="nfcnavbar-navbar__right-group">
            <LoginLink item={loginItem} onItemClick={handleItemClick} isMobile={false}/>
            {/* <SocialLinks items={socialItems} isMobile={false}/> */}
                <div className="footernfc-social-media-icons-unique-navbar">
                                      <a href="https://instagram.com/nownfc" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                                      <a href={`https://wa.me/91551651651515`} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faWhatsapp} /></a>
                                  </div>
            <CallToActionButton onClick={handleCtaClick} isMobile={false}/>
          </div>
          <div className="nfcnavbar-navbar__mobile-controls">
            <button 
              ref={mobileMenuTriggerRef} 
              className={`nfcnavbar-navbar__mobile-menu-trigger ${isMobileMenuOpen ? 'nfcnavbar-is-open' : ''}`} 
              onClick={toggleMobileMenu} 
              aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"} 
              aria-expanded={isMobileMenuOpen} 
              aria-controls="nfcnavbar-mobileMenuOverlay"> 
                <svg viewBox="0 0 100 100" width="28" height="28">
                    <path className="nfcnavbar-line nfcnavbar-top" d="m 30,33 h 40 c 13.100415,0 14.380204,31.80258 6.899646,33.421777 -24.612039,5.327373 9.016154,-52.337577 -12.75751,-30.563913 l -28.284272,28.284272" />
                    <path className="nfcnavbar-line nfcnavbar-middle" d="m 70,50 h -40" />
                    <path className="nfcnavbar-line nfcnavbar-bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-31.573519 -5.589646,-33.421777 -24.612039,-5.327373 9.016154,52.337577 -12.75751,30.563913 l -28.284272,-28.284272" />
                </svg>
            </button>
          </div>
        </nav>
      </header>
      <MobileMenuOverlay
        isOpen={isMobileMenuOpen}
        menuItems={menuItems}
        loginItem={loginItem}
        socialItems={socialItems}
        activeSection={activeSection}
        onItemClick={handleItemClick}
        ctaOnClick={handleCtaClick}
        onClose={toggleMobileMenu}
      />
    </>
  );
};

const App = () => {
 return (
   <NavbarProvider>
     <SmartNavbar />
   </NavbarProvider>
 );
};

export default App;